import Vue from 'vue';

export default new Vue({
  data: {},
  methods: {
    /**
     * @description
     * Load list of users
     *
     * @returns {Promise<object[]>}
     */
    async getUsers(rawParams) {
      const params = {
        qLastName: rawParams.qLastName || undefined,
        qFirstName: rawParams.qFirstName || undefined,
        qEmail: rawParams.qEmail || undefined,
        qUsername: rawParams.qUsername || undefined,
        qBranchId: rawParams.qBranchId || undefined,
        qStatus: rawParams.status || undefined,
        sortOrder: rawParams.sortOrder || undefined,
        orderBy: rawParams.orderBy || undefined,
        offset: rawParams.offset || 0,
        pageSize: rawParams.pageSize || 10,
      };
      return await this.$http.get('/api/users', { params })
        .then(response => response);
    },
    async getUserNames() {
      return await this.$http.get('/api/user-names')
        .then(response => response);
    },
    /**
     * @description
     * Update user data
     * @param {object} userData
     * @returns {Promise<void>}
     */
    async updateUser(userData) {
      return await this.$http.put(`/api/users/${userData.userId}`, userData);
    },
    /**
     * @description
     * Change user password
     * @param {object} userData
     * @returns {Promise<void>}
     */
    async changePassword(userData) {
      const url = typeof userData.userId !== 'undefined'
        ? `/api/users/${userData.userId}/change-password`
        : `/api/settings/change-password`;
      return await this.$http.put(url, { password: userData.password });
    },
    /**
     * @description
     * Create user
     * @param {object} userData
     * @returns {Promise<void>}
     */
    async createUser(userData) {
      return await this.$http.post('/api/users', userData);
    },

    /**
     * @description
     * Load given user details
     *
     * @param {number} userId
     * @returns {Promise<*|HttpResponse>}
     */
    async getUserDetails(userId) {
      if (!userId) {
        return await false;
      }
      return await this.$http.get(`/api/users/${userId}`);
    },

  }
});